module.exports = __webpack_public_path__ + "img/Lee_Street_Drone_0002.92ddb01a.jpg";